import { jsxs as z, jsx as r, Fragment as A } from "react/jsx-runtime";
import * as i from "react";
import { memo as D, useMemo as s, useState as Y, useEffect as j, useCallback as $ } from "react";
import "dayjs";
import { m as K, A as Q, v as U, T as d } from "./period-BbmcGyLd.js";
import { Row as q, Col as J } from "antd";
import { u as X } from "./styled-components.browser.esm-BFmoFexH.js";
import { SimpleSelect as M, IconContainer as T, WrapperItem as P, WrapperRoot as Z } from "@biron-data/react-components";
import { useLanguageResolver as G, useEventResolver as O } from "@biron-data/react-contexts";
function C(a, t) {
  return /* @__PURE__ */ i.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, a), /* @__PURE__ */ i.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
  }));
}
const ee = i.forwardRef(C);
function te(a, t) {
  return /* @__PURE__ */ i.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, a), /* @__PURE__ */ i.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}
const B = i.forwardRef(te), de = ({ children: a, name: t }) => /* @__PURE__ */ r(Z, { icon: B, label: "configuration-label-period", children: /* @__PURE__ */ r(P, { name: t, children: a }) }), W = (a, t) => a.map((o) => ({
  value: o.id.toString(),
  label: t.getTranslatedName(o)
})), me = D(function({
  value: t,
  onChange: o,
  forTarget: b,
  withOverrideOption: c,
  overrideOptionLabel: h,
  withDateSlicerGranularity: w,
  span: m = 12,
  getPopupContainer: R,
  environmentId: v,
  GACategory: f,
  name: S,
  loadPeriods: E
}) {
  var L;
  const l = G(), p = O(), k = s(
    () => h ?? l.get("chart-definition-period-from-dashboard"),
    [l, h]
  ), [n, F] = Y();
  j(() => {
    E(v).then((e) => {
      F(e.payload);
    });
  }, [v, E]);
  const y = K(n ?? []), _ = s(
    () => b ? W((n ?? []).filter((e) => e.type === Q.dynamic && e.canBeDeleted === !1), l) : [
      ...c ? [{
        value: null,
        label: k
      }] : [],
      ...y.map(({ title: e, presets: u }) => ({
        label: l.get(e),
        value: null,
        options: W(u, l)
      }))
    ],
    [b, l, k, n, y, c]
  );
  j(() => {
    t && n && !n.find((e) => e.code === t.code) && (o == null || o(c ? void 0 : n.find((e) => e.code === U.MONTH_TO_DATE.code)));
  }, [o, n, t, c]);
  const x = s(
    () => w ? [
      c && {
        value: null,
        label: l.get("chart-definition-granularity-from-dashboard")
      },
      ...[d.DAY, d.WEEK, d.MONTH, d.QUARTER, d.YEAR].map((e) => ({
        value: e,
        label: l.get(`calendar-granularity-${e.toLowerCase()}`)
      }))
    ].filter(Boolean) : [],
    [l, w, c]
  ), H = $(
    (e) => {
      const u = (n ?? []).find((V) => V.id.toString() === e);
      f && (u ? p.capture({
        category: f,
        action: "add_period"
      }) : p.capture({
        category: f,
        action: "remove_period"
      })), o == null || o(u);
    },
    [f, p, o, n]
  ), g = s(() => m < 20 ? 24 - m - 1 : 24, [m]), N = s(() => g === 24 ? 0 : 1, [g]);
  return /* @__PURE__ */ z(q, { gutter: [0, 5], children: [
    /* @__PURE__ */ r(I, { span: m, children: /* @__PURE__ */ r(M, { name: S, style: { width: "100%", margin: 0 }, showSearch: !0, labelIcon: /* @__PURE__ */ r(T, { color: "var(--light-grey)", children: /* @__PURE__ */ r(ee, {}) }), options: _, getPopupContainer: R, value: ((L = t == null ? void 0 : t.id) == null ? void 0 : L.toString()) ?? null, onSelect: H }) }),
    x.length > 0 && /* @__PURE__ */ r(A, { children: /* @__PURE__ */ r(I, { span: g, offset: N, children: /* @__PURE__ */ r(P, { name: "dateSlicerGranularity", children: /* @__PURE__ */ r(M, { name: S, style: { width: "100%" }, options: x, labelIcon: /* @__PURE__ */ r(T, { color: "var(--light-grey)", children: /* @__PURE__ */ r(B, {}) }), getPopupContainer: R }) }) }) })
  ] });
}), I = X(J)`
    &&& .ant-select-selection-item {
        margin-left: 0px;
        align-content: center;
        align-items: center;
        display: flex;
    }
`;
export {
  ee as F,
  me as P,
  de as a
};
//# sourceMappingURL=PeriodSelector-BPitTrQ8.js.map
